var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tippy",rawName:"v-tippy",value:(_vm.content?{}:{trigger:'manual'}),expression:"content?{}:{trigger:'manual'}"}],attrs:{"content":_vm.content}},[_c('strong',[_vm._v(_vm._s(_vm.prefix)+" "+_vm._s(_vm.v)+" "+_vm._s(_vm.suffix))]),(!_vm.noOldValue)?_c('div',{staticClass:"delta",class:{
				'huge-delta': _vm.big,
				'delta-zero':_vm.value==_vm.oldValue,
				'delta-up':_vm.value>_vm.oldValue,
	      'delta-down':_vm.value<_vm.oldValue}},[_vm._v(_vm._s(_vm.perDiff(_vm.value, _vm.oldValue))+" %")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }